import { render, staticRenderFns } from "./NotificationDropdownMenu.vue?vue&type=template&id=9629cbec&scoped=true&"
import script from "./NotificationDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./NotificationDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDropdownMenu.vue?vue&type=style&index=0&id=9629cbec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9629cbec",
  null
  
)

export default component.exports